import { useTranslation } from 'react-i18next';

import ButtonDemo from '../button';
import HeroTitle from '../heroTitle';
import AdvantagesCard from './components/advanCard';
import NexoraIcon from './components/NexoraIcon';
import style from './style.module.scss';

export function Advantages() {
    const { t } = useTranslation();

    return (
        <section
            id="advantages"
            className={`container section ${style.advantages}`}
        >
            <div className={style.advantages__title}>
            <HeroTitle title={t('advantages.label')}>
                {t('advantages.title.before')}{' '}
                <span className="accent">
                    {t('advantages.title.accent')}
                </span>{' '}
                {t('advantages.title.after')}
                <br />
                {t('advantages.title.bottom')}
            </HeroTitle>
            </div>

            <div className={style.advantages__diver}></div>

            <div className={style.advantages__container}>
                <div className={style['advantages__container-card']}>
                    <AdvantagesCard
                        title={t('advantages.competitors.title')}
                        subtitle={t('advantages.competitors.subtitle')}
                        items={t('advantages.competitors.items', {
                            returnObjects: true,
                        })}
                        variant="default"
                    />

                    <AdvantagesCard
                        title={t('advantages.nexora.title')}
                        subtitle={t('advantages.nexora.subtitle')}
                        items={t('advantages.nexora.items', {
                            returnObjects: true,
                        })}
                        variant="blue"
                        icon={<NexoraIcon />}
                    />
                </div>

                <ButtonDemo
                    size="large"
                    color="black"
                    directIcon
                >
                    {t('button.titleCalculate')}
                </ButtonDemo>
            </div>
        </section>
    );
}